import { userInfoFrag } from '../../../../../utils/type/user.common-type';
import { workOfferInfoFrag } from '../../../../../utils/type/work.common-types';

export const workDataFrag = `
    id
    dateFrom
    folderId
    serviceId
    person {
        id
    }
    tags
    users {
        ${userInfoFrag}
    }
    ${workOfferInfoFrag}
    workData {
        ... on WorkDataContinuousRecordObject {
            data
            form
            presence
        }
    }
`;
